class ObjectStorage {
  private storage: Storage;
  private key: string;

  constructor(storage: Storage, key: string) {
    this.storage = storage;
    this.key = key;
  }

  get<T = unknown>(): T {
    try {
      const item = this.storage.getItem(this.key);
      return item ? (JSON.parse(item) as T) : (null as unknown as T);
    } catch {
      return null as unknown as T;
    }
  }

  set(value: unknown): void {
    try {
      this.storage.setItem(this.key, JSON.stringify(value));
    } catch {
      // ignore storage errors
    }
  }

  clear(): void {
    this.storage.removeItem(this.key);
  }
}

export default ObjectStorage;
